export default function formatPhone(phone) {
    if (!phone) return '-'
    let value = phone
        .replaceAll(/[-]|\s/g, '')
        .replace('+48 ', '')
        .replace('+48', '')
    if (value?.length === 11 && value.slice(0, 2) === '48') {
        value = value.slice(2)
    }
    if (value?.length === 9) {
        value = value.match(/(\d{0,3})(\d{0,3})(\d{0,3})/)
        return value
            ? '+48 ' +
                  (!value[2]
                      ? value[1]
                      : value[1] +
                        '-' +
                        value[2] +
                        (value[3] ? '-' + value[3] : ''))
            : null
    }
    return value || '-'
}
